/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerNotificationsSummaryDtoModel, CustomerNotificationsSummaryDtoModelType } from "./CustomerNotificationsSummaryDtoModel"
import { CustomerNotificationsSummaryDtoModelSelector } from "./CustomerNotificationsSummaryDtoModel.base"
import { DriverNotificationsSummaryDtoModel, DriverNotificationsSummaryDtoModelType } from "./DriverNotificationsSummaryDtoModel"
import { DriverNotificationsSummaryDtoModelSelector } from "./DriverNotificationsSummaryDtoModel.base"
import { RootStoreType } from "./index"


/**
 * PublishingSummaryDtoBase
 * auto generated base class for the model PublishingSummaryDtoModel.
 */
export const PublishingSummaryDtoModelBase = ModelBase
  .named('PublishingSummaryDto')
  .props({
    __typename: types.optional(types.literal("PublishingSummaryDto"), "PublishingSummaryDto"),
    routesCount: types.union(types.undefined, types.number),
    ordersCount: types.union(types.undefined, types.number),
    driverNotifications: types.union(types.undefined, types.late((): any => DriverNotificationsSummaryDtoModel)),
    customerNotifications: types.union(types.undefined, types.null, types.late((): any => CustomerNotificationsSummaryDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PublishingSummaryDtoModelSelector extends QueryBuilder {
  get routesCount() { return this.__attr(`routesCount`) }
  get ordersCount() { return this.__attr(`ordersCount`) }
  driverNotifications(builder: string | DriverNotificationsSummaryDtoModelSelector | ((selector: DriverNotificationsSummaryDtoModelSelector) => DriverNotificationsSummaryDtoModelSelector) | undefined) { return this.__child(`driverNotifications`, DriverNotificationsSummaryDtoModelSelector, builder) }
  customerNotifications(builder: string | CustomerNotificationsSummaryDtoModelSelector | ((selector: CustomerNotificationsSummaryDtoModelSelector) => CustomerNotificationsSummaryDtoModelSelector) | undefined) { return this.__child(`customerNotifications`, CustomerNotificationsSummaryDtoModelSelector, builder) }
}
export function selectFromPublishingSummaryDto() {
  return new PublishingSummaryDtoModelSelector()
}

export const publishingSummaryDtoModelPrimitives = selectFromPublishingSummaryDto().routesCount.ordersCount
